import { useCallback, useEffect, useRef } from "react";
import { StoreProvider, useStore } from "./stores";
import { defaultValue } from "./stores/state";
import Routes from "./routes";

import { getUserInfo, getIfActivityExpired } from "./api";

import ActivityBridge from "./utils/bridgeTool/ActivityBridge";
import LoginBridge from './utils/bridgeTool/LoginBridge';
import { isNetease } from "./utils/common";
import { shareConfigOvertime } from "./common/constant";
import { Toast } from "antd-mobile";

import "./assets/entry.scss";

const activity = new ActivityBridge();

const loginBridge = new LoginBridge({
	platform: "h5",
	host: "mail.163.com",
	loginCallback: () => {
		window.Tongji.show('mail_login_suc');
        setTimeout(() => {
            window.location.reload();
        }, 100)
	}
});

function App() {
	const [store, dispatch] = useStore()
	const audioRef = useRef<any>(null);
	const initData = useRef<boolean>(false);

	const initLoginStatus = useCallback(async () => {
		// 端内打开需要获取登录态
		const isMaster = await activity.isMaster();
		if (isMaster) {
			const info = await activity.getClientInfo();
			console.log('客户端信息：', info);
			window.Tongji.setCommonData('masterVersion', info.version)
			dispatch({
				type: 'changeState',
				payload: {
					isMaster: true,
					masterClientInfo: info
				}
			})

			// 大师app内预先设置分享信息
			console.log('prepareShare', shareConfigOvertime);
			activity.prepareShare(shareConfigOvertime);


			try {
				const res: any = await LoginBridge.getBaseInfo();
				window.Tongji.setCommonData("channel", res?.channel);
			} catch (error) {
				window.Tongji.data("appHost_getBaseInfo_error");
			}

		}

		if (!store.isLogin) {
			if (isMaster) {
				console.log('是否大师环境：', isMaster);
				const res = await activity.isMasterLogin();
				console.log('是否登录大师号', res);
				if (res?.status === 1) {
					const loginRes = await activity.loginMaster();
					console.log('大师号登录态：', loginRes);
					if (loginRes?.loginToken) {
						dispatch({
							type: 'changeState',
							payload: {
								isLogin: true,
								mastersess: loginRes?.loginToken,
								dashi_uid: loginRes?.muid,
							}
						})
						try {
							window.Tongji.setMasterAccount(loginRes?.muid || '');
						} catch(e) {}
					}
					const masterInfoRes = await activity.getMasterInfo();
					console.log('大师号信息:', masterInfoRes)
					dispatch({
						type: 'changeState',
						payload: {
							nickname: masterInfoRes.nickname || store.nickname,
							phone: masterInfoRes.phoneNumber || store.phone
						}
					})
					dispatch({
						type: 'changeState',
						payload: {
							isInit: true,
						}
					})
				} else {
					window.Tongji.data("no_master_login");
					// 查看是否已有邮箱帐号登录态
					const { result: userRes }: any = await getUserInfo();
					console.log('获取当前用户信息：', userRes);
					if ((userRes?.code === 200 && !userRes?.result?.uid) || userRes?.code === 203) {
						// 存在内域可用邮箱的时候，展示帐号列表给用户选择
						const accountListRes = await activity.getAccounts();
						console.log('帐号列表：', accountListRes);
						let autoLoginAccount = '';
						if (accountListRes.current && isNetease(accountListRes.current)) {
							autoLoginAccount = accountListRes.current;
						} else {
							accountListRes.list.forEach(item => {
								if (isNetease(item.uid) && item.verified && !autoLoginAccount) {
									autoLoginAccount = item.uid;
								}
							})
						}
						if (autoLoginAccount) {
							try {
								window.Tongji.show('mail_login_module')
								window.Tongji.show('mail_login_module_first_page')
							} catch(e) {}
							loginBridge.showLoginModule();
							// console.log('autologin的帐号：', autoLoginAccount);
							// try {
							// 	loginBridge.autoLoginEmail(autoLoginAccount, (result: any) => {
							// 		if (!result.error) {
							// 			//TODO reload问题排查，只要加了reload就一直死循环，不加则不进入该逻辑分支。。离谱
							// 			setTimeout(() => {
							// 				console.log('reload 页面');
							// 				window.location.reload();
							// 			}, 100)
							// 		} else {
							// 			Toast.show({
							// 				content: '自动登录失败'
							// 			})
							// 		}
							// 	})
							// } catch(e) {
							// 	Toast.show({
							// 		content: '自动登录失败'
							// 	})
							// }
						}

					} else if (userRes?.code === 200 && userRes?.result?.uid) {
						console.log('端内；更新用户信息', userRes);
						dispatch({
							type: 'changeState',
							payload: {
								isLogin: true,
								uid: userRes?.result?.uid,
								phone: userRes?.result?.mobile
							},
						})
						try {
							window.Tongji.setUid(userRes?.result?.uid || '');
						} catch(e){}
					} else if (userRes?.code !== 200 &&  userRes?.code !== 203 && userRes?.code !== 1005) {
						Toast.show({
							content: '获取用户信息失败'
						})
					}
					dispatch({
						type: 'changeState',
						payload: {
							isInit: true,
						}
					})
				}
			} else {
				const { result: userRes }: any = await getUserInfo();
				console.log('端外：更新用户信息: ', userRes)
				if (userRes?.code === 200 && userRes?.result?.uid) {
					console.log('端外：更新用户信息', userRes);
					dispatch({
						type: 'changeState',
						payload: {
							isLogin: true,
							uid: userRes?.result?.uid,
							phone: userRes?.result?.mobile,
						},
					});
					try {
						window.Tongji.setUid(userRes?.result?.uid || '');
					} catch(e){}
				} else if (userRes?.code !== 200 && userRes?.code !== 203 && userRes?.code !== 1005) {
					Toast.show({
						content: '获取用户信息失败'
					})
				}
				dispatch({
					type: 'changeState',
					payload: {
						isInit: true,
					}
				})
			}
		} else {
			dispatch({
				type: 'changeState',
				payload: {
					isInit: true,
				}
			})
		}
	}, [dispatch, store.isLogin])

	useEffect(() => {
		if (!initData.current) {
			initLoginStatus();
			initData.current = true;
		}
	}, [initLoginStatus])

	const masterLeavePage = useCallback(async () => {
		const isMaster = await activity.isMaster();
		if (isMaster) {
			activity.setPageOptions({
				noticeBeforePageLeave: true
			});
			const audio: HTMLAudioElement | null = document.getElementById('bg-audio') as HTMLAudioElement;

			await activity.PageWillLeave(async function () {
				// 离开页面时候把音乐关闭
				dispatch({
					type: 'changeState',
					payload: {
						playMusic: false
					}
				})
				audio && audio.pause()
				return activity.closePage();
			});
			let hidden: string;
			let visibilityChange: string;
			if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
				hidden = "hidden";
				visibilityChange = "visibilitychange";
				//@ts-ignore
			} else if (typeof document.msHidden !== "undefined") {
				hidden = "msHidden";
				visibilityChange = "msvisibilitychange";
				//@ts-ignore
			} else if (typeof document.webkitHidden !== "undefined") {
				hidden = "webkitHidden";
				visibilityChange = "webkitvisibilitychange";
			} else {
				hidden = "hidden";
				visibilityChange = "visibilitychange";
			}


			document.addEventListener(visibilityChange, () => {
				//@ts-ignore
				if (document[hidden]) {
					audio && audio.pause()
				}
			}, false);

			window.addEventListener('beforeunload', () => {
				audio && audio.pause()
			}, false);

		}
	}, [dispatch])

	useEffect(() => {
		masterLeavePage();
	}, [masterLeavePage])

	useEffect(() => {
		if (localStorage.getItem(`fighting-${store.nickname || store.uid || store.phone}`) === '1') {
			dispatch({
				type: 'updateRuleAgreeStatus',
				payload: true,
			})
		}
	}, [store.nickname, store.uid, store.phone, dispatch])

	useEffect(() => {
		if (audioRef.current) {
			audioRef.current.load()
		}
		setTimeout(() => {
			window.scrollTo({ top: 0 });
		}, 1000)
	}, [])

	return (
		<>
			<Routes />
			<audio id="bg-audio" ref={audioRef} preload='auto' loop src="https://mail.163.com/hd/2022-fighting/hallo-machine.mp3"></audio>
			{/* 预加载动画大图 */}
			<div className="preload-loading-long"></div>
		</>
	)
}

export default function Entry() {
	return (
		<StoreProvider {...defaultValue}>
			<div className="entry-wrapper">
				<App />
			</div>
		</StoreProvider>
	);
}
